import React, { useState } from "react";
import ReactDatatable from "@mkikets/react-datatable";
import { useGetRewardSettingsQuery, useUpdateRewardSettingsStatusMutation } from "../../../redux/rewardSettingsApi";
import { Button } from "react-bootstrap";
import EditRewardSettings from "../../partial/EditRewardSettings";
import AddRewardSettings from "../../partial/AddRewardSettings";
import { toast } from "react-toastify";

import { useTranslation } from "react-i18next";

function RewardSettings() {
    const { t } = useTranslation();
    const { data: apiResponse } = useGetRewardSettingsQuery();
    const [updateRewardSettingsStatus] = useUpdateRewardSettingsStatusMutation();

    const rewardSettings = apiResponse?.data || [];

    // Edit Modal State
    const [showEdit, setShowEdit] = useState(false);
    const [showAdd, setShowAdd] = useState(false);
    const [editData, setEditData] = useState({});

    const handleEdit = (reward) => {
        setEditData(reward);
        setShowEdit(true);
    };

    const handleToggleStatus = async (reward) => {
        const newStatus = reward.status === "enabled" ? "disabled" : "enabled";
        try {
            const response = await updateRewardSettingsStatus({
                id: reward.id,
                status: newStatus
            }).unwrap();

            if (response.status) {
                toast.success(response.message || `Reward ${newStatus} successfully!`);
            } else {
                toast.error(response.message || "Failed to update status");
            }
        } catch (error) {
            toast.error("Error updating status");
            console.error("Error updating status:", error);
        }
    };

    const columns = [
        {
            key: "srno.",
            text: t('sr_no'),
            className: "sr_no.",
            align: "left",
            sortable: true,
            cell: (row, index) => index + 1,
        },
        {
            key: "cryptocurrency",
            text: t('cryptocurrency'),
            className: "cryptocurrency",
            align: "left",
            sortable: true,
            cell: (record) => {
                return <>
                    {record.from_coin_name && <img style={{ width: "20px", height: "20px", marginRight: "8px" }} src={record.from_coin_logo} alt="" />}
                    {record.from_coin_name || 'N/A'} {record.nw_symbol ? `(${record.nw_symbol})` : ''}
                </>;
            },
        },
        {
            key: "reward_amount",
            text: t('amount'),
            className: "reward_amount",
            align: "left",
            sortable: true,
        },

        {
            key: "status",
            text: t('status'),
            className: "status",
            align: "left",
            sortable: true,
        },
        {
            key: "action",
            text: t('actions'),
            className: "Action d-flex",
            align: "left",
            sortable: true,
            cell: (record) => {
                return (
                    <>
                        <Button variant="info" size="sm" className="me-1" onClick={() => handleEdit(record)}>
                            {t('edit')}
                        </Button>
                        <Button
                            variant="success"
                            size="sm"
                            onClick={() => handleToggleStatus(record)}
                        >
                            {t('enable')}
                        </Button>
                    </>
                );
            },
        },
    ];

    const config = {
        page_size: 5,
        length_menu: [5, 10, 20, 50],
        filename: "Reward Settings List",
        no_data_text: t('no_record_found'),
        button: {
            // print: true,
            // csv: true,
        },
        language: {
            filter: t('search_in_records'),

            pagination: {
                first: t('first'),
                previous: t('previous'),
                next: t('next'),
                last: t('last'),
            },
        },
        show_length_menu: true,
        show_filter: false,
        show_pagination: true,
        show_info: true,
    };

    return (
        <section className="section dashboard">
            <div className="pagetitle d-flex align-items-center justify-content-between mb-4">
                <h1>{t('reward_settings')}</h1>
                <Button variant="primary" onClick={() => setShowAdd(true)}>
                    {t('add_reward_settings')}
                </Button>
            </div>

            <div className="card">
                <div className="card-body pt-4">
                    <ReactDatatable
                        key={`datatable-reward-settings`}
                        config={config}
                        records={rewardSettings}
                        columns={columns}
                        dynamic={false}

                    />

                </div>
            </div>

            <EditRewardSettings
                show={showEdit}
                onHide={() => setShowEdit(false)}
                rewardSettings={editData}
            />

            <AddRewardSettings
                show={showAdd}
                onHide={() => setShowAdd(false)}
            />
        </section>
    );
}

export default RewardSettings;
